import { useSelector } from "react-redux";

export const useIsUserMix = () => {
  const { userData } = useSelector(state => state.auth);

  return userData?.is_mix;
};

